import type {CSSProperties} from 'react';
import {WEDGE_SELLING} from '@territory/tokens';
import {radius, space, weight} from '../scale.js';
import {wedgeExactRole} from './wedgeRoles.js';

export type WedgeSellingLook = 'selling-choice' | 'selling-choice-on' | 'selling-chip-remove' | 'selling-suggest';

/* Released Selling settings (deal size, sales cycle, competitors and Why people pick you): four controls. The choice chip is a pill with
   7px by 12px padding, a 5px gap and 12.5px semibold type on the elevated fill in the secondary ink; chosen, it takes the accent fill and
   the fixed white ink. The suggestion chip is a pill with 6px by 11px padding, 12.5px medium type in the label ink on the elevated fill
   with a hairline card border. The remove mark of a competitor or angle chip is an 18px circle on a fixed 8% black veil, centered round a
   caller-drawn glyph, with the label ink, no border and no padding. It sets no shrink, as the source does not. Each reads the exact legacy
   roles, so the shipped ink rules keep matching. The caller owns the labels, the glyphs, the handlers and the layout. */
const CHOICE_PY = 7, CHOICE_GAP = 5, SELLING_FONT = 12.5, SUGGEST_PY = 6, SUGGEST_PX = 11, REMOVE_SIZE = 18;

export function wedgeSellingStyle(look: WedgeSellingLook): CSSProperties {
  if (look === 'selling-chip-remove') return {
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: REMOVE_SIZE, height: REMOVE_SIZE, borderRadius: radius.pill,
    background: WEDGE_SELLING.removeFill, border: 0, color: wedgeExactRole('label'), cursor: 'pointer', padding: 0, fontFamily: wedgeExactRole('font'),
  };
  if (look === 'selling-suggest') return {
    padding: `${SUGGEST_PY}px ${SUGGEST_PX}px`, borderRadius: radius.pill, background: wedgeExactRole('bgElev'), color: wedgeExactRole('label'),
    border: `1px solid ${wedgeExactRole('cardBorder')}`, fontSize: SELLING_FONT, fontWeight: weight.medium, fontFamily: wedgeExactRole('font'), cursor: 'pointer',
  };
  const on = look === 'selling-choice-on';
  return {
    padding: `${CHOICE_PY}px ${space[3]}px`, borderRadius: radius.pill, background: wedgeExactRole(on ? 'accent' : 'bgElev'),
    color: on ? WEDGE_SELLING.ink : wedgeExactRole('labelSec'), border: 0, cursor: 'pointer', fontSize: SELLING_FONT, fontWeight: weight.semibold,
    fontFamily: wedgeExactRole('font'), display: 'inline-flex', alignItems: 'center', gap: CHOICE_GAP,
  };
}
